import {gestoreModuli} from "./class.gestoremoduli";
import {inputHandler} from "./class.inputhandler";
import {palette} from "./class.palette";

/**
 * Tipo => casse
 *
 * default - cassa60
 * 1 - cassa120
 * 2 - cassa vuota (uso con triangoli)
 * 3 - cassa120x60
 * 4 - cassa vuota (uso con texture)
 * 5 - cass180
 */

class Cassa {
    constructor(scene, assetsManager, tipo, parentMesh) {
        switch (tipo) {
            // modulo da 120
            case 1:
                this.task = assetsManager.addMeshTask("cassa", "", "dist/assets/imports/", "cassa120/cassa120.babylon");
                break;
            // modulo vuoto
            case 2:
                this.task = assetsManager.addMeshTask("cassa", "", "dist/assets/imports/", "cassaVuota/cassaVuota.babylon");
                break;
           /* case 3:
                this.task = assetsManager.addMeshTask("cassa", "", "assets/imports/", "cassaVuota/cassaVuota.babylon");
                break;*/
            // modulo vuoto da usare con texture
            case 4:
                this.task = assetsManager.addMeshTask("cassa", "", "dist/assets/imports/", "cassaVuota/cassaVuota.babylon");
                break;
            // modulo da 180
            case 5:
                this.task = assetsManager.addMeshTask("cassa", "", "dist/assets/imports/", "cassa180/cassa180.babylon");
                break;
            case 6:
                this.task = assetsManager.addMeshTask("cassa", "", "dist/assets/imports/", "cassa120orizzontale/cassa120orizzontale.babylon");
                break;
            // modulo da 60
            default:
                this.task = assetsManager.addMeshTask("cassa", "", "dist/assets/imports/", "cassa60/cassa60.babylon");
                break;
        }
        this._scene = scene;
        this._parentMesh = parentMesh;
        // this._currentColor = new BABYLON.Color3.FromHexString(palette._defaultBodyColor);
        this._currentColor = palette._defaultBodyColor;

        this.task.onSuccess = (task) => {
            let materialeCassa = new BABYLON.StandardMaterial("texture1", this._scene);

            const cassa = task.loadedMeshes[0];

            cassa.isPickable = true;
            cassa.outlineWidth = 0.60;
            cassa.outlineColor = new BABYLON.Color3(0, 0, 0);
            cassa.renderOutline = false;
            cassa.parent = this._parentMesh;
            cassa.material = materialeCassa;
            cassa.material.diffuseColor = palette.rgbToBabylon(this._currentColor);
            /*cassa.material.diffuseColor = palette.rgbToBabylon(this._currentColor);*/
            cassa.material.specularColor = new BABYLON.Color3(.2, .2, .2);
            /*cassa.material.metallic = 0;
            cassa.material.roughness = 0.35;*/

            // sceneManager._shadowGenerator.addShadowCaster(cassa, true);
            // cassa.receiveShadow = true;

            this._mesh = cassa;

            cassa.actionManager = new BABYLON.ActionManager(this._scene);

            cassa.actionManager.registerAction(
                new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickUpTrigger, function (m) {
                    if (inputHandler._isClickValid) {
                        gestoreModuli.updateBodyToCurrentColor();
                    }
                })
            );
            cassa.actionManager.registerAction(
                new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger, function (m) {
                    if (!inputHandler._isMouseDown) {
                        gestoreModuli.highlightBody(true);
                    }
                })
            );
            cassa.actionManager.registerAction(
                new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger, function (m) {
                    gestoreModuli.highlightBody(false);
                })
            );
        }
    }

    setColor(color) {
        this._currentColor = color;
        this._mesh.material.diffuseColor = palette.rgbToBabylon(this._currentColor);
    }

    highlightCassa(status, color) {
        if (status) {
            this._mesh.material.diffuseColor = palette.rgbToBabylon(color);
        } else {
            this._mesh.material.diffuseColor = palette.rgbToBabylon(this._currentColor);
        }
    }

    destroy() {
        this._mesh.dispose();
    }
}

export default Cassa;
